export enum SettingsModuleRoutes {
    SETTINGS = 'settings',

    ADDRESS_BOOK_MANAGEMENT = 'address-book-management',
    CASE_NUMBER_MANAGEMENT = 'case-number-management',
    CASE_SETTINGS_MANAGEMENT = 'case-settings-management',
    DEPARTMENT_MANAGEMENT = 'department-management',
    OFFICE_MANAGEMENT = 'office-management',
    RECIPIENT_OPTIONS = 'recipient-options',
    TEMPLATE_MANAGEMENT = 'template-management',
    THIRD_PARTY_CREDENTIALS = 'third-party-credentials-management',
    USER_MANAGEMENT = 'user-management',
    WORKFLOW_MANAGEMENT = 'workflow'
}
